import { isRegisterApi } from "@/api/auth-api";
import { domainSignal } from "@/utils/domain-store";
import { doGoogleLogin } from "@/utils/google-auth";
import { useSignal } from "@preact-signals/safe-react";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { Toast } from "antd-mobile";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { imageConfig } from "../../../../config/config";
import { getText } from "../../../../utils/util";
import "./index.css";

const GOOGLE_CLIENT_ID =
  "39845133901-f402t02cq4922s5tf80vkvc17c0kcj6r.apps.googleusercontent.com";

export default function PageLogin({
  doLogin,
  companyData,
  nologinmsg,
  loginmsg,
}) {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const { t: translate, i18n } = useTranslation();
  const { t } = useTranslation();
  const lan = localStorage.getItem("i18n");
  const appStatus = localStorage.getItem("appStatus");
  const [language, setLanguages] = useState(lan ? lan : "zh");
  const [passwordType, setPasswordType] = useState(true);
  const [loginData, setLoginData] = useState<any>({
    username: "",
    password: "",
  });

  // google
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [invit, setInvit] = useState("");

  const handleGoogleButtonClick = () => {
    if (googleLoginRef.current) {
      const button = googleLoginRef.current.querySelector('div[role="button"]');
      if (button) {
        (button as HTMLElement).click();
      }
    }
  };

  const googleLoginRef = useRef<HTMLDivElement>(null);
  const idToken = useSignal("");
  const inviteType = localStorage.getItem("inviteType");

  const handleGoogleLoginSuccess = async (credentialResponse: any) => {
    idToken.value = credentialResponse.credential;
    if (inviteType !== "1") {
      doGoogleLogin({
        idToken: idToken.value,
        translate: t,
      });
      return;
    }

    const res = await isRegisterApi({ idToken: idToken.value });
    if (res.data) {
      doGoogleLogin({
        idToken: idToken.value,
        translate: translate,
      });
    } else {
      setShowInviteModal(true);
    }
  };

  const handleGoogleLoginError = () => {
    Toast.show("Google auth error");
  };
  // google

  return (
    <div className="min-h-screen bg-neutral-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-neutral-800 rounded-xl shadow-card p-6 animate-fade-in">
        {/* 顶部logo区域 */}
        <div className="flex justify-between items-center mb-8">
          <div className="flex items-center">
            <img
              src={imageConfig.baseImageUrl + companyData?.companyLogoName}
              className="h-10 object-contain"
              alt="Company Logo"
            />
          </div>
          <div
            className="p-2 bg-neutral-700 rounded-full cursor-pointer hover:bg-neutral-600 transition-colors"
            onClick={() => {
              navigate("/chatcenter");
            }}
          >
            <img src="/img/kf.png" className="w-5 h-5" alt="Customer Service" />
          </div>
        </div>

        {showInviteModal ? (
          <div className="flex flex-col gap-6 p-4 w-full">
            <div className="flex flex-col gap-2">
              <label
                htmlFor="modal-invite-code"
                className="text-gray-700 text-sm"
              >
                {t("请输入邀请码")}
              </label>
              <input
                id="modal-invite-code"
                type="text"
                placeholder={t("请输入邀请码")}
                className="  text-gray-700 placeholder-gray-400 rounded-md px-4 py-3 !border border-gray-700 ring-1 ring-gray-700 focus:border-gradient-primary focus:ring-2 focus:ring-gradient-primary"
                value={invit}
                onChange={(e) => {
                  setInvit(e.target.value);
                }}
              />
            </div>
            {/* 取消按钮，透明背景，白色文字 */}
            <button
              type="button"
              onClick={() => {
                setShowInviteModal(false);
                setInvit("");
              }}
              className="
      rounded-md transition-colors duration-200
      focus:outline-none focus:ring-2 focus:ring-offset-2
      px-4 py-2 text-base
      bg-transparent text-gray-700
      hover:bg-gray-200
      focus:ring-gray-700
      w-full leading-6 tracking-[-0.2px] font-bold text-center
      border border-gray-700
      flex items-center justify-center gap-2 h-[42px]
    "
            >
              {t("取消")}
            </button>
            {/* 确认按钮，绿色背景，白色文字 */}
            <button
              type="button"
              onClick={() => {
                if (invit) {
                  doGoogleLogin({
                    idToken: idToken.value,
                    translate: t,
                    invit,
                  });

                  // if (googleLoginRef.current) {
                  //   const button =
                  //     googleLoginRef.current.querySelector(
                  //       'div[role="button"]'
                  //     );
                  //   if (button) {
                  //     (button as HTMLElement).click();
                  //   }
                  // }
                } else {
                  Toast.show(t("请输入邀请码"));
                }
              }}
              className="
      font-semibold rounded-md transition-colors duration-200
      focus:outline-none focus:ring-2 focus:ring-offset-2
      px-4 py-2 text-base
      bg-gradient-primary text-white
      hover:bg-gradient-primary
      focus:ring-gradient-primary
      w-full leading-6 tracking-[-0.2px] font-bold text-center
      border border-transparent
      flex items-center justify-center gap-2 h-[42px]
    "
            >
              {t("确认")}
            </button>
          </div>
        ) : (
          <div className="space-y-6">
            {/* 表单区域 */}
            {/* 用户名输入 */}
            <div className="space-y-2">
              <div className="text-neutral-300 text-sm font-medium">
                {translate(getText("賬號"))}
              </div>
              <div className="relative">
                <input
                  className="w-full bg-neutral-700 border border-neutral-600 rounded-lg py-3 px-4 text-white focus:outline-none focus:ring-2 focus:ring-primary transition-all"
                  type="text"
                  value={loginData.username}
                  onChange={(e) => {
                    setLoginData({
                      ...loginData,
                      username: e.target.value,
                    });
                  }}
                  placeholder={translate(getText("請輸入賬號"))}
                />
              </div>
            </div>

            {/* 密码输入 */}
            <div className="space-y-2">
              <div className="text-neutral-300 text-sm font-medium">
                {translate(getText("密碼"))}
              </div>
              <div className="relative">
                <input
                  type="password"
                  className="w-full bg-neutral-700 border border-neutral-600 rounded-lg py-3 px-4 text-white focus:outline-none focus:ring-2 focus:ring-primary transition-all"
                  value={loginData.password}
                  onChange={(e) => {
                    setLoginData({
                      ...loginData,
                      password: e.target.value,
                    });
                  }}
                  placeholder={translate(getText("請輸入密碼"))}
                />
              </div>
            </div>

            {/* 忘记密码链接 */}
            <div className="flex justify-end">
              <div
                className="text-primary-light text-sm cursor-pointer hover:text-primary transition-colors"
                onClick={() => {
                  navigate("/reloadPassword");
                }}
              >
                {translate(getText("忘記密碼?"))}
              </div>
            </div>

            {/* 错误消息显示 */}
            {loginmsg && (
              <div className="text-danger text-sm py-1">{loginmsg}</div>
            )}

            {/* 登录按钮 */}
            <button
              className="w-full bg-gradient-primary py-3 rounded-lg text-black font-medium hover:opacity-90 transition-opacity"
              onClick={() => {
                doLogin(loginData);
              }}
            >
              {translate(getText("登錄"))}
            </button>

            {/* Google 登录按钮 - 改成普通按钮 */}
            <button
              type="button"
              onClick={handleGoogleButtonClick}
              className="rounded-md transition-colors duration-200 px-4 py-2 text-base bg-transparent hover:bg-gray-200 w-full text-base leading-6 tracking-[-0.2px] font-bold text-center border border-gray-700 flex items-center justify-center gap-2 h-[42px]"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.64 9.20454C17.64 8.56636 17.5827 7.95272 17.4764 7.36363H9V10.8444H13.8436C13.635 11.9699 13.0009 12.9231 12.0477 13.5613V15.8194H14.9564C16.6582 14.2526 17.64 11.9453 17.64 9.20454Z"
                  fill="#4285F4"
                />
                <path
                  d="M9 18C11.43 18 13.4673 17.1941 14.9564 15.8195L12.0477 13.5613C11.2418 14.1013 10.2109 14.4204 9 14.4204C6.65591 14.4204 4.67182 12.8372 3.96409 10.71H0.957275V13.0418C2.43818 15.9831 5.48182 18 9 18Z"
                  fill="#34A853"
                />
                <path
                  d="M3.96409 10.7099C3.78409 10.1699 3.68182 9.59307 3.68182 8.99989C3.68182 8.40671 3.78409 7.82989 3.96409 7.28989V4.95807H0.957273C0.347727 6.17353 0 7.54807 0 8.99989C0 10.4517 0.347727 11.8263 0.957273 13.0417L3.96409 10.7099Z"
                  fill="#FBBC05"
                />
                <path
                  d="M9 3.57955C10.3214 3.57955 11.5077 4.03364 12.4405 4.92545L15.0218 2.34409C13.4632 0.891818 11.4259 0 9 0C5.48182 0 2.43818 2.01682 0.957275 4.95818L3.96409 7.29C4.67182 5.16273 6.65591 3.57955 9 3.57955Z"
                  fill="#EA4335"
                />
              </svg>
              {t("login.sign_in_with_google")}
            </button>

            {/* 注册和下载链接 */}
            <div className="flex justify-between text-sm pt-2">
              <span
                className="text-primary-light cursor-pointer hover:text-primary transition-colors"
                onClick={() => {
                  navigate("/register");
                }}
              >
                {translate(getText("立即註冊"))}
              </span>
              {domainSignal.value?.appStatus === 1 && (
                <span
                  className="text-primary-light cursor-pointer hover:text-primary transition-colors"
                  onClick={() => {
                    navigate("/download");
                  }}
                >
                  App{(lan == "zh" ? "" : " ") + translate(getText("下載"))}
                </span>
              )}
            </div>
          </div>
        )}

        {/* 底部导航链接 */}
        <div className="mt-8 pt-4 border-t border-neutral-700">
          <div className="flex justify-center gap-2 text-sm text-neutral-400">
            <div
              className="cursor-pointer hover:text-primary-light transition-colors"
              onClick={() => {
                navigate("/changeline");
              }}
            >
              {translate(getText("切換線路"))}
            </div>
            <div className="text-neutral-600">/</div>
            <div
              className="cursor-pointer hover:text-primary-light transition-colors"
              onClick={() => {
                navigate("/changelanguage");
              }}
            >
              {translate(getText("切換語言"))}
            </div>
          </div>
        </div>
      </div>
      <div className="invisible h-0 w-0 absolute">
        {/* Google OAuth Provider 和按钮 */}
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <div
            ref={googleLoginRef}
            className="invisible flex w-full justify-center"
          >
            <GoogleLogin
              theme="outline"
              locale={i18n.language}
              size="medium"
              onSuccess={handleGoogleLoginSuccess}
              onError={handleGoogleLoginError}
            />
          </div>
        </GoogleOAuthProvider>
      </div>
    </div>
  );
}
